<template>
  <div class="main" :class="skinName">
    <div class="wrapper">
      <van-sticky>
        <div style="background-color: #F0F0F0">
          <div class="barcode-wrap">
            <div class="head">
              <van-icon name="manager" size="40"></van-icon>
              <p class="name">{{ name }}</p>
            </div>
            <div class="barcode code-box">
              <div style="display: flex;flex-direction: row;align-items: center">
                <svg id="barcode"
                     jsbarcode-format="CODE128"
                     :jsbarcode-value="serialno"
                     jsbarcode-textmargin="0"
                     jsbarcode-fontoptions="bold"
                >
                  >
                </svg>
                <div class="switchover" @click="toQRCode">
                  <van-icon size="40" name="qr" />
                  切换
                </div>
              </div>
              <div class="barcode-sub">
                <p><span>体检号</span> {{ serialno }}</p>
                <p><span>身份证</span> {{ cardid }}</p>
              </div>
            </div>
          </div>
          <van-swipe :loop="false">
            <van-swipe-item>
              <div class="queue-wrap">
                <div class="queue-wrap-header">当前候检科室</div>
                <ul>
                  <li v-for="(item,index) in queueData" :key="index">
                    <p>{{ item.ClinicName }} </p>
                    <div class="list-dec">
                      <p>您排在第{{ item.OrderNo }}位</p>
                      <p v-if="!awaitTimeShow">约等{{ item.WaitTime }}分钟<span style="font-size: .7em">（仅供参考）</span>
                      </p>
                    </div>
                  </li>
                  <li v-if="queueData.length <= 0">
                    <van-icon name="warning" color="#c3a79a"></van-icon>
                    暂无排队信息
                  </li>
                </ul>
                <div class="swipe-tip">
                  左滑更多内容
                  <van-icon name="arrow"/>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <van-grid style="margin-top: 8px;">
                <van-grid-item @click="$router.push({name: 'preconsultation'})">
                  <img src="@/assets/images/question.svg"/>
                  <span class="van-text">检前问卷</span>
                </van-grid-item>

                <van-grid-item v-if="satisfactionFixationShow" @click="$router.push({name: 'survey'})">
                  <img src="@/assets/images/survey.svg"/>
                  <span class="van-text">调查问卷</span>
                </van-grid-item>
                <van-grid-item v-if="taskShow && taskSize>0" :to="{name: 'letterConsent', query: {serialNo:serialno}}">
                  <van-icon name="todo-list-o" size="32"></van-icon>
                  <van-badge :content="taskSize">
                    <span class="van-text">待办任务</span>
                  </van-badge>
                </van-grid-item>
                <van-grid-item>
                  <span class="van-text">&emsp;</span>
                </van-grid-item>
                <van-grid-item>
                  <span class="van-text"></span>
                </van-grid-item>
                <van-grid-item>
                  <span class="van-text"></span>
                </van-grid-item>
                <van-grid-item>
                  <span class="van-text"></span>
                </van-grid-item>
                <van-grid-item>
                  <span class="van-text"></span>
                </van-grid-item>
              </van-grid>
            </van-swipe-item>
          </van-swipe>

        </div>
        <div class="scrollBar" v-if="hintText!=''">
          <marquee direction="left" scrollamount="2">
            {{ hintText }}
          </marquee>
        </div>
      </van-sticky>
      <van-tabs :title-active-color="tabsSkin.titleActiveColor" :title-inactive-color="tabsSkin.titleInactiveColor"
                :color="tabsSkin.color" class="m-van-tabs">
        <van-tab title="未检项目" title-style="font-size:1em;font-weight:500">
          <h3 style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
            <span>未检项目</span>
            <van-button size="small"
                        type="info"
                        style="margin-right: 1em;font-size: 1.2em;font-weight: bold;"
                        @click="refresh">刷新 <van-icon
                name="replay"/></van-button>
          </h3>
          <div style="padding: 5px 5px 5px 5px">
            <div class="unCheck-wrap" v-for="(item,index) in unCheckedList" :key="index">
              <div class="unCheck">
                <H3 sty>{{ index + 1 }}、{{ item.GroupName }}</H3>
              </div>
              <div class="unCheck-box-rq">
                <div class="unCheck-box" v-if="showButton">
                  <van-button size="mini" color="#df3737" v-if="checkNameFilter(item) && !showWaive"
                              style="width: 5em;color: #cdcdcd"
                              @click="check_cancel(1,item)" :disabled="isDisabled"> 弃检
                  </van-button>
                  <van-button size="mini" color="#FEA443" v-if="checkNameFilter(item) && !showChangDate"
                              style="width: 5em;color: #FF976A"
                              @click="check_cancel(2,item)" :disabled="isDisabled"> 改期
                  </van-button>
                  <!--                 FF976A-->
                  <van-button size="mini" color="#59C36A" v-if="checkNameFilter(item) && !showFinish"
                              style="width: 5em;color: #FF976A"
                              @click="check_cancel(3,item)" :disabled="isDisabled"> 完成
                  </van-button>
                  <span style="font-size: 14px;color: #de4242">{{ item.CheckStatus | checkStatusFilter }}</span>
                </div>
              </div>
              <div class="unCheck-tips" v-if="showPrompt">{{ item.Prompt }}</div>
            </div>
          </div>
          <div class="pickup-method" v-if="unCheckedList.length<1 && isSubmit && reportReceiveShow ">
            <span style="font-size: 16px;font-weight: bold">项目已全部检完，请选择报告领取方式</span>
            <van-radio-group v-model="radio" style="margin-top: 0.5em">
              <van-radio style="margin-left: 0.8em;margin-top: 0.8em" name="0">电子报告</van-radio>
              <van-radio style="margin-left: 0.8em;margin-top: 0.8em" name="1">自取</van-radio>
              <van-radio style="margin-left: 0.8em;margin-top: 0.8em" name="2">邮寄</van-radio>
              <van-radio v-if="companyID!='0000'" style="margin-left: 0.8em;margin-top: 0.8em" name="3">发放单位
              </van-radio>
            </van-radio-group>
            <van-button color="#1989FA" size="middle" round style="margin-top: 1.5em" @click="submitReport(radio)">
              确认提交
            </van-button>
          </div>
        </van-tab>
        <van-tab title="已检项目" title-style="font-size:1em;font-weight:500">
          <h3 style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">已检项目
            <van-button size="small"
                        type="info"
                        style="margin-right: 1em;font-size: 1.2em;font-weight: bold;"  @click="refresh">刷新 <van-icon
                name="replay"/></van-button></h3>
          <van-steps direction="vertical" :active="0" active-icon="location-o" inactive-icon="success"
                     finish-icon="flag-o">
            <van-step v-for="(item,index) in checkedList" :key="index">
              <h3>{{ item.GroupName }}</h3>
              <p>{{ item.DepartmentName }} {{ DateTimeConvert(item.CheckDate, null) }}</p>
            </van-step>
          </van-steps>
        </van-tab>
        <van-tab title="温馨提示" title-style="font-size:1em;font-weight:500">
          <h3>温馨提示</h3>
          <html-panel :url="getPageUrl"></html-panel>
        </van-tab>
      </van-tabs>
    </div>
    <!--扫码层-->
    <div class="scan-code" v-if="showScanCode">
      <div class="scan-code-header">
        <div>
          <van-image :src='headimgurl'></van-image>
          <h4 style="font-size: 3em;margin-top:1em;">{{ nickname }}您好！</h4>
          <p style="font-size: 2em;margin-top: 1em;">欢迎来到{{ hospiatlName }}</p>
        </div>
      </div>
      <div class="scan-code-body">
        <div class="input-wrap">
          <van-icon name="bars" color="gray" size="large"></van-icon>
          <!-- 允许输入数字，调起带符号的纯数字键盘 -->
          <van-field v-model="serialno" type="number" label="" placeholder="请输入流水号或扫码识别"/>
          <van-image :src='require("@/assets/images/btn_scancode.svg")' width="42" height="42"
                     @click="qrCode"></van-image>
        </div>
        <div v-if="searchHistory.length>0" class="searchHistoryDel">
          <span style="font-size: 14px">历史搜索记录</span>
          <van-icon name="delete" size="18" @click="clearSearchHistory"/>
        </div>
        <div class="History-box" style="margin: 0 4em;">
          <div class="History-box-item" v-for=" (item,index) in  searchHistory" :key="index"
               @click="searchHistoryClick(item)">
            {{ item }}
          </div>
        </div>
        <div style="margin: 0 4em;">
          <van-button type="info" size="large" block round @click="getCurrentCheckUserInfoBySeriaoNo()">
            <van-icon name="search" size="large"></van-icon>
            查 询
          </van-button>
        </div>
        <div class="operator-tip">
          <div style="margin-right: 1em">
            <h4>使用方法：</h4>
            <p>1、输入体检指引单上的体检流水号进行查询。</p>
            <p>2、点击扫码按钮扫描条形码进行查询</p>
            <!--            <p>2、实时查看当前体检等候队列，避免过号。</p>-->
            <!--            <p>3、已检未检项目一目了然，避免漏项。</p>-->
          </div>
          <van-image :src='require("@/assets/images/pic_scancode.jpg")' width="80"></van-image>
        </div>
      </div>
    </div>
    <div class="side-right">
      <van-button type="info" size="small" v-if="!showScanCode && showParkingTicket && parkingTicketPopShow"
                  @click="$router.push({name: 'parkingTicket', query: {serialno:serialno}})" text="领停车券"></van-button>
      <van-button type="info" size="small" v-if="!showScanCode"
                  @click="$router.push({name: 'preconsultation'})" text="检前问卷"></van-button>
      <van-button type="info" size="small" v-if="!showScanCode && satisfactionFixationShow" @click="$router.push({name: 'survey'})" text="调查问卷"></van-button>
      <van-button type="info" size="small" v-if="!showScanCode" name="qr" @click="showScanCode = true" text="扫码查询"></van-button>
      <van-button type="info" size="small" v-if="isOpenId && weChatPushShow" @click="isStartPush(serialno)" text="接收消息"></van-button>
      <van-button type="info" size="small" v-if="!showScanCode" @click="$router.push({name: 'home'})" text="返回首页"></van-button>
    </div>
    <div style="position: fixed;bottom: 0;left: 0;right: 0;z-index: 999;display: flex;flex-direction: row;">
      <van-button v-if="payShow && payUrl!='' && payType=='0'" type="primary" size="large" block :url="payUrl">
        <van-icon :name="icon_wechat_pay" style="vertical-align: middle;margin-right: .5em;"/>
        支付体检费
      </van-button>
      <!--有问题功能未完成2024-12-27luotong-->
<!--      <van-button v-if="payShow" type="primary" size="large" block-->
<!--                  :to="{name: 'payDetail', query: {serialno:serialno}}">-->
<!--        <van-icon :name="icon_wechat_pay" style="vertical-align: middle;margin-right: .5em;"/>-->
<!--        支付体检费-->
<!--      </van-button>-->
    </div>

    <!-- 带输入框 -->
    <van-dialog v-model="checkShow" :title="checkTile" show-cancel-button :lazy-render="false"
                :before-close="beforeClose">
      <van-field
          type="textarea"
          v-model="message"
          rows="2"
          autosize
          autofocus
          maxlength="50"
          :placeholder="reasonText"
          show-word-limit
          class="message"
      />
    </van-dialog>
    <van-dialog v-model="tipsShow" :title="tipsTile" :lazy-render="false" :before-close="toSkip"
                :confirm-button-text="TipsType==1?'下一步':'完成'" cancel-button-text="暂不评价" confirm-button-color="#1989fa"
                :show-cancel-button="TipsType==1">
      <div style="display: flex;flex-direction: column;margin-top: 1em;justify-content: center;align-items: center">
        <div style="display: flex;flex-direction: column;text-align: center;width: 17em; font-size: 14px">
        <span style="margin-bottom: 0.5em">
          {{ tipsText }}
        </span>
          <span style="font-size: 14px;color: red;font-weight: bold;margin-bottom: 1.5em">
          {{ tipsRedText }}
        </span>
        </div>
      </div>
    </van-dialog>
    <van-dialog
        v-if="unCheckedList.length<1 && payFeesConfig"
        title="温馨提示"
        :message="showCompleteProjectTips?showCompleteProjectTips:'体检项目已全部完成，请到前台进行缴费'"
        v-model="payFeesShow"
        :lazy-render="false"
    />
    <van-dialog v-if="weChatPushShow" v-model="weChatPushConfirmShow" title="温馨提示" show-cancel-button
                :before-close="onPushBeforeClose">
      <div style="display: flex;flex-direction: column;margin-top: 1em;justify-content: center;align-items: center">
        <div style="display: flex;flex-direction: column;text-align: center;width: 17em; font-size: 14px">
        <span style="margin-bottom: 0.5em;font-size: 16px">
          {{ weChatPushTips ? weChatPushTips : '是否启用微信公众号排队信息推送服务。' }}
        </span>
          <span style="font-size: 14px;color: red;font-weight: bold;margin-bottom: 1.5em">
          {{ weChatPushTipsRed ? weChatPushTipsRed : '请关注微信公众号' }}
        </span>
        </div>
      </div>
    </van-dialog>
    <!--    用户信息二维码-->
    <van-popup v-model="QRCodeShow" description="请将二维码对准扫码口">
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <vue-qr
            :text="QRCodeUserInfo"
            :size="200"
        ></vue-qr>
        <div style="display: flex;flex-direction: column;font-size: 14px;padding: 0.5em">
          <div style="display: flex;align-items: center;justify-content: center;">{{ name }}</div>
          <div>{{ phone|HidePhoneStr }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getProcCheckProgress,
  getProcGetQueueAll,
  getCurrentCheckUserInfoBySeriaoNo,
  updateGroup,
  queryIsFood, submitReport, getParking
} from '@/api/module/user'
import {getConsentFormCount, getPayUrlBySerialno, getUserInfoByPatientid} from '@/api/module/index'
import {encrypt, decrypt} from "@/assets/utils/cryptoUtil";
import {Toast, Dialog} from "vant";
import HtmlPanel from "@/components/HtmlPanel";
import JsBarcode from "jsbarcode"
import wx from "weixin-js-sdk"
import {DateTimeConvert, HidePhoneStr} from "@/assets/utils/utils"
import VueQr from "vue-qr";

export default {
  name: "index",
  components: {HtmlPanel,VueQr},
  data() {
    return {
      skinName: window.appSetting.queuePage.skinName,
      tabsSkin: window.appSetting.tabs,
      serialno: "",
      unCheckedList: [],//未检项目数据
      checkedList: [],//项目数据
      queueData: [],//排队数据
      show: false,
      serialnoVal: "",
      payShow: window.g.VUE_APP_PAY_ENABLE,
      payType: window.g.VUE_APP_PAY_TYPE,
      queueTips: window.g.VUE_APP_QUEUE_TIPS,
      user: {},
      cardid: "",
      name: "",
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice.html',
      hospiatlName: window.g.VUE_APP_HOSPITALNAME,
      showScanCode: true,
      headimgurl: '',
      nickname: '',
      payUrl: '',//支付链接
      icon_wechat_pay: require("@/assets/images/WechatPayWhite.svg"),
      taskShow: window.g.VUE_APP_TASK_TODO,
      taskSize: 0,//任务数量
      searchHistory: [],//历史查询记录
      checkShow: false,
      message: '', // 理由
      checkTile: '',
      checkItem: {},
      tipsShow: false,
      tipsTile: '',
      tipsText: '',
      tipsRedText: '',
      hintText: '',
      radio: '1', //报告领取方式
      companyID: '', // 单位id
      isSubmit: false,
      TipsType: 1, // 选项框控制按钮 1 项目改状态  0确认提交
      reasonText: '请您输入原因,以便后续服务开展！',
      awaitTimeShow: window.g.VUE_APP_AWAIT_TIME_SHOW, // 控制等待时间显示
      showButton: window.g.VUE_APP_NAVIGATION_EXAMINE_SHOW_BUTTON, // 控制弃检 改期 的按钮显示
      showPrompt: window.g.VUE_APP_SHOW_PROMPT, // 未检项目是否显示提示信息控制
      showParkingTicket: window.g.VUE_APP_PARKING_TICKET_SHOW, // 控制停车券显示控制
      parkingTicketPopShow: false, // 停车券弹窗
      payFeesShow: false, // 提示缴费弹窗
      payFeesConfig: window.g.VUE_APP_PAY_FEES_SHOW,// 控制缴费弹窗
      payFeesSize: 1, // 控制弹窗只显示一次
      reportReceiveShow: window.g.VUE_APP_REPORT_RECEIVE_SHOW,// 控制是否显示报告领取方式
      isDisabled: false,// 防止重复点击
      // 控制智慧导检 是否显示弃检按钮
      showWaive: window.g.VUE_APP_EXAMINE_COMPLETE_WAIVE,
      // 控制智慧导检 是否显示改期按钮
      showChangDate: window.g.VUE_APP_EXAMINE_COMPLETE_CHANG_DATE,
      // 控制智慧导检 是否显示完成按钮
      showFinish: window.g.VUE_APP_EXAMINE_COMPLETE_FINISH,
      // 控制智慧导检 体检项目完成后 温馨提示内容
      showCompleteProjectTips: window.g.VUE_APP_EXAMINE_COMPLETE_TIPS,
      // 是否微信授权（用于微信推送）
      isOpenId: false,
      //微信推送按钮和提示框是否开启
      weChatPushShow: window.g.VUE_APP_NAVIGATION_WECHAT_PUSH_SHOW,
      // 提示框提示内容
      weChatPushTips: window.g.VUE_APP_NAVIGATION_WECHAT_PUSH_TIPS,
      // 提示框提示内容 红字部分
      weChatPushTipsRed: window.g.VUE_APP_NAVIGATION_WECHAT_PUSH_TIPS_RED,
      // 是否显示推送确认提示框
      weChatPushConfirmShow: false,
      patientid: undefined,
      // 展示二维码
      QRCodeShow: false,
      // 二维码用户的信息
      QRCodeUserInfo: '',
      phone: '',
      // 用户基础信息
      loginuser: {},
      // 轮询时间
      pollingInterval: window.g.POLLING_TIME,
      // 防重复点击
      isRefreshing:false,
      satisfactionFixationShow: window.g.VUE_APP_SATISFACTION_FIXATION_SHOW
    }
  },
  mounted() {
    wx.checkJsApi({
      jsApiList: ['chooseImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        // console.log(res)
      }
    });
  },
  created() {
    clearInterval()
    let _this = this
    //微信用户信息
    if (window.g.VUE_APP_ISWECHAT == '1') {
      let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      if (userinfo) {
        this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.headimgurl = this.userinfo.headimgurl
        this.nickname = this.userinfo.nickname
      } else {
        this.headimgurl = require("@/assets/images/head.svg")
        this.nickname = ''
      }
    } else {
      this.headimgurl = require("@/assets/images/head.svg")
      this.nickname = ''
    }
    let querySerialNo = this.$route.query.serialno

    if (querySerialNo != undefined) {
      //传了参数进来的
      this.serialno = querySerialNo
      this.getParking()
      this.getCurrentCheckUserInfoBySeriaoNo()
      if (this.payType) {
        this.getPayUrlBySerialno()
      }
    }
    const storedHistory = window.localStorage.getItem('SearchData');
    if (storedHistory) {
      this.searchHistory = JSON.parse(storedHistory);
    }
  },
  filters: {
    HidePhoneStr: function (value) {
      let val = decrypt(value)
      return HidePhoneStr(val)
    },
    checkStatusFilter(value) {
      if (value == '2') {
        return '已弃检'
      } else if (value == '3') {
        return '续检'
      } else if (value == '4') {
        return '报告先出'
      }
    },
    checkStatusFilterStyle(value) {
      if (value == '2') {
        return 'color:red'
      } else if (value == '3') {
        return '续检'
      } else if (value == '4') {
        return '报告先出'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.chatTimer)
    this.chatTimer = null
  },
  methods: {
    refresh_progress(serialno) {
      var _this = this;
      let params = {
        serialno: serialno
      }
      getProcCheckProgress(params).then(res => {
        if (res.code == 200) {
          _this.$nextTick(function () {
            _this.unCheckedList = []
            _this.checkedList = []
            res.data.forEach(item => {
              // 去掉了 || item.CheckStatus == "2"
              if (item.CheckStatus == "0") {
                _this.unCheckedList.push(item);
              }
              if (item.CheckStatus == "1") {
                _this.checkedList.push(item);
              }
            })
            if (_this.unCheckedList.length == 0) {
              if (_this.payFeesSize < 2) {
                _this.payFeesSize += 1
                _this.payFeesShow = true
              }
            }
            _this.queryIsFood(_this.serialno);
          })
        }
      })
    },
    refresh_queue(serialno) {
      var _this = this;
      let params = {
        serialno: serialno
      }
      getProcGetQueueAll(params).then(res => {
        if (res.code == 200) {
          _this.$nextTick(function () {
            _this.queueData = []
            Dialog.close()
            let dialogTxt = ""
            res.data.forEach(item => {
              if (item.ClinicName != "") {
                if (this.queueTips) {
                  this.queueTips.forEach(tem => {
                    if (tem.clinicid == item.ClinicID) {
                      dialogTxt = dialogTxt + tem.msg
                    }
                  })
                }
                _this.queueData.push(item)
              }
            })
            if (dialogTxt != "") {
              Dialog.alert({
                message: dialogTxt,
                theme: 'round-button',
              }).then(() => {
                // on close
              });
            }
          })
        }
      })
    },
    getCurrentCheckUserInfoBySeriaoNo() {
      var _this = this;
      if (_this.serialno.trim() == "") {
        Toast({
          message: '流水号不能为空',
          icon: 'warning',
        });
        return;
      }
      let params = {
        serialno: _this.serialno
      }
      this.getParking()
      this.getConsentFormCount()
      getCurrentCheckUserInfoBySeriaoNo(params).then(res => {
        if (res.code == 200) {
          let resData = res.data;
          if (resData == null) {
            Toast({
              message: '未查询到体检信息',
              icon: 'warning',
            });
            clearInterval(_this.chatTimer)
            _this.chatTimer = null
          } else {
            _this.$nextTick(function () {
              JsBarcode("#barcode", _this.serialno, {
                lineColor: "#000",
                width: 3,
                height: 60,
                displayValue: false
              });
            })
            let params = {
              patientid: this.$encruption(encrypt(resData.PatientID)),
              serialno: this.$encruption(encrypt(resData.SerialNo))
            }
            getUserInfoByPatientid(params).then(res => {
              // 20240918 ZLS 获取用户信息
              _this.phone = res.data.phone
              _this.loginuser = res.data
              console.log("openID", res.data.wechatid)
              if (res.data.wechatid) {// 如果openID有值则不需要开启微信推送按钮（默认推送） 20240918 ZLS
                console.log("openID", res.data.wechatid)
                _this.isOpenId = false
              } else if (window.g.VUE_APP_ISWECHAT == '1') { // 如果openID没值则需要显示微信推送按钮和弹框 20240918 ZLS
                _this.patientid = res.data.patientid
                _this.isStartPush()
                _this.isOpenId = true
              }
              localStorage.setItem("GuideUser", JSON.stringify(res.data))
            })
            _this.cardid = this.hideCardid(decrypt(resData.CardID))
            _this.name = this.hideName(resData.Name)
            _this.companyID = resData.CompanyID
            _this.refresh_progress(_this.serialno);
            _this.refresh_queue(_this.serialno);

            // 禁止重复轮询
            if (_this.chatTimer == null) {
              _this.chatTimer = setInterval(() => {
                _this.refresh_progress(_this.serialno);
                _this.refresh_queue(_this.serialno);
              }, this.pollingInterval?this.pollingInterval:9000) // 轮询时间自定义
            }
            _this.showScanCode = false

            // 定义存储键名
            const SEARCH_KEY = 'SearchData';
            // 如果搜索历史已达上限，移除最旧记录
            const maxHistoryLength = 10; // 例如，最多保留10条记录
            if (this.searchHistory.length >= maxHistoryLength) {
              this.searchHistory.shift();
            }
            // 添加至搜索历史
            this.searchHistory.push(_this.serialno + "." + _this.name);
            this.searchHistory = this.removeDuplicates(this.searchHistory);
            // 存储到 session storage
            // sessionStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
            window.localStorage.setItem(SEARCH_KEY, JSON.stringify(this.searchHistory));
          }
        }
        this.isDisabled = false;
        return;
      })
    },
    getPayUrlBySerialno() {
      let params = {
        serialno: encrypt(this.serialno)
      }
      getPayUrlBySerialno(params).then(res => {
        if (res.code == 200) {
          if (res.data == "") {

          } else {
            this.payUrl = res.data
            console.log(this.payShow)
            console.log(this.payType)
            console.log(this.payUrl)
          }
        }
      })
    },
    hideCardid(str) {
      if (str == "") {
        return "";
      }
      var len = str.length - 3 - 4;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return str.substring(0, 3) + xing + str.substring(str.length - 4);
    },
    hideName(str) {
      if (str == "") {
        return ""
      }
      var len = str.length - 1;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return xing + str.substring(str.length - 1);
    },
    qrCode() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          alert(result)
        }
      })
    },
    //2024-03-18 ZLS  新增获取待办任务的数量
    getConsentFormCount() {
      let params = {
        serialNo: this.serialno
      }
      getConsentFormCount(params).then(res => {
        if (res.code == 200 && res.data > 0) {
          this.taskSize = res.data;
        }
      })
    },
    // 从 session storage 中获取搜索历史
    searchHistoryClick(item) {
      this.serialno = item.split(".")[0];
    },
    removeDuplicates(arr) {
      return [...new Set(arr)];
    },
    // 清除所有搜索历史
    clearSearchHistory() {
      this.searchHistory = [];
      sessionStorage.removeItem('searchHistory');
    },
    // 删除指定索引处的记录
    removeSearchRecord(index) {
      this.searchHistory.splice(index, 1);
      sessionStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    },
    // 弃检 改期 完成
    check_cancel(index, item) {
      if (index == 1) {
        this.checkTile = "确认拒检"
        this.reasonText = "请您输入拒检原因,以便后续服务开展！"
        this.checkItem = item
        this.checkItem.CheckStatus = "2"
        this.checkShow = true;
      } else if (index == 2) {
        this.checkTile = "确认改期"
        this.reasonText = "请您输入改期原因,以便后续服务开展！"
        this.checkItem = item
        this.checkItem.CheckStatus = "3"
        this.checkShow = true;
      } else if (index == 3) {
        this.checkTile = "确认完成"
        this.reasonText = "请您输入完成原因,以便后续服务开展！"
        this.checkItem = item
        this.checkItem.CheckStatus = "1"
        this.checkShow = true;
      }
      this.isDisabled = true;
    },
    // 确认状态
    beforeClose(action, done) {
      this.initTips()
      if (action === 'confirm') {
        let params = {
          serialno: this.checkItem.SerialNo,
          groupid: this.checkItem.GroupID,
          status: this.checkItem.CheckStatus,
          reason: this.message
        }
        updateGroup(params).then(e => {
          this.TipsType = "0"
          this.tipsTile = "温馨提示"
          if (e.data == "1") {
            this.tipsShow = true;
            this.tipsText = "请电话联系前台续检日期"
            this.tipsRedText = "*女性客户月经干净3天后可约"
          } else if (e.data == "0") {
            this.tipsShow = true;
            this.tipsText = "请电话联系前台续检日期"
          }
        })
        done();
      } else {
        this.checkItem.CheckStatus
        done();
      }
      this.checkShow = false;
      this.checkItem = "";
      this.message = ""
      this.getCurrentCheckUserInfoBySeriaoNo()
    },
    // 状态过滤
    checkNameFilter(value) {
      if (value.CheckStatus == '0' && value.GroupName != '检验采血') {
        return true
      } else {
        return false
      }
    },
    // 查询是否有空腹项目
    queryIsFood(serialno) {
      let groupIDs = [];
      this.unCheckedList.forEach(item => {
        if (item.CheckStatus == "0") {
          groupIDs.push(item.GroupID);
        }
      })
      groupIDs = groupIDs.join(',');
      let params = {
        groupIDs: groupIDs,
        serialno: serialno
      }
      queryIsFood(params).then(res => {
        if (res.data.isFood == "1") {
          this.hintText = "有空腹项目，请暂不吃早餐"
        } else if (res.data.isFood == "0") {
          this.hintText = ""
        }
        if ((res.data.paperReport == " " || res.data.paperReport == "1") && res.data.reportMode == " ") {
          this.isSubmit = true
        }
      })
    },
    // 交单  报告发放方式
    submitReport() {
      this.initTips()
      let params = {
        serialNo: this.serialno,
        reportMode: this.radio
      }
      submitReport(params).then(res => {
        this.TipsType = "1"
        this.isSubmit = false
        if (this.radio == 2 && res.data==1) {
          this.tipsTile = "温馨提示"
          this.tipsShow = true;
          this.tipsText = "尊敬的客户，请您对本次体检服务进行评价,我们将根据您的宝贵意见持续改善体检流程！"
          this.tipsRedText = "*请至前台填写邮寄地址信息"
        }else if(this.radio == 2){
          this.tipsTile = "温馨提示"
          this.tipsShow = true;
          this.tipsText = "请至前台填写邮寄地址信息！"
          this.tipsRedText = ""
          this.TipsType = "0"
        }else if (res.data == 1) {
          this.tipsTile = "即将跳转"
          this.tipsShow = true;
          this.tipsText = "尊敬的客户，请您对本次体检服务进行评价,我们将根据您的宝贵意见持续改善体检流程！"
        }
      })
    }
    ,
    initTips() {
      this.tipsTile = ""
      this.tipsRedText = ""
      this.tipsText = ""
    },
    toSkip(action, done) { // 跳转到满意度调查问卷： 开启 弹窗VUE_APP_REPORT_RECEIVE_SHOW；满意度调查问卷未填写（Questionnaire 根据流水号查不出来的情况）状态下跳转至问卷页面
      if (action === 'confirm' && this.TipsType == "1") {
        clearInterval(this.chatTimer)
        this.chatTimer = null
        this.$router.push({name: 'survey'})
      } else {
        done();
      }
    },
    DateTimeConvert(date, type) {
      return DateTimeConvert(date, type)
    },
    // 查询是否可以领停车券
    getParking() {
      let params = {
        serialNo: this.serialno
      }
      getParking(params).then(res => {
        console.log(res)
        if (res.data.parkingTicket == 1) {
          this.parkingTicketPopShow = true;
        }
      })
    },
    // 是否开启排队推送
    isStartPush() {
      this.weChatPushConfirmShow = true;
    },
    // 确认开启推送
    onPushBeforeClose(action, done) {
      if (action === "confirm") {
        this.geToWechatAuthorization();
      } else {
        return done();
      }
    },
    //请求微信授权接口获取openId,后续请求后台开始推送排队消息
    geToWechatAuthorization() {
      // 跳转之前清空会话缓存
      sessionStorage.removeItem("userinfo");
      localStorage.setItem("isPushWeChat", true);
      localStorage.setItem("PushPatientID", this.patientid);
      this.$router.push({name: 'wechatAuth'})
    },
    toQRCode() {
      this.QRCodeShow = true
      const loginuser = this.loginuser
      const userInfo = {
        physicalno: loginuser.physicalno ? loginuser.physicalno : "", // 体检编号
        name: loginuser.name ? loginuser.name : "", // 姓名
        phone: loginuser.phone ? loginuser.phone : "", // 手机号
        patientid: loginuser.patientid ? loginuser.patientid : "", // 用户id
        cardid: loginuser.cardid ? loginuser.cardid : "" // 身份证
      }
      this.QRCodeUserInfo = JSON.stringify(userInfo)
      this.QRCodeUserInfo = encrypt(this.QRCodeUserInfo)
      // console.log(this.QRCodeUserInfo)
      // console.log("解密后",decrypt(this.QRCodeUserInfo))
    },
    // 刷新按钮
    refresh(){
      if (this.isRefreshing) {
        this.$toast("正在刷新中，请稍后再试");
        return;
      }
      this.isRefreshing = true;
      this.getCurrentCheckUserInfoBySeriaoNo()
      setTimeout(() => {
        this.isRefreshing = false;
      }, window.g.REFRESHING_TIME? window.g.REFRESHING_TIME : 3000);
    },
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 6rem;
  /*background-image: linear-gradient(to bottom right, #10E3E9, #5091F9, #10E3E9);*/
  background-color: #f0f0f0;
}

.wrapper {
  margin: 1rem;
  font-size: 2.4rem
}

/*条码样式*/
.barcode {
  text-align: center;
}

.barcode + * {
  clear: both
}

#barcode {
  white-space: nowrap;
  zoom: .8; /* -webkit-transform: scaleX( .5); transform: scaleX(.5);*/
}

#barcode div {
  display: inline-block;
  height: 60px
}

.barcode .bar1 {
  border-left: 2px solid black
}

.barcode .bar2 {
  border-left: 4px solid black
}

.barcode .bar3 {
  border-left: 6px solid black
}

.barcode .bar4 {
  border-left: 8px solid black
}

.barcode .space0 {
  margin-right: 0
}

.barcode .space1 {
  margin-right: 2px
}

.barcode .space2 {
  margin-right: 4px
}

.barcode .space3 {
  margin-right: 6px
}

.barcode .space4 {
  margin-right: 8px
}

.barcode label {
  clear: both;
  display: block;
  text-align: center;
  font: 16px/34px helvetica
}

.barcode-wrap {
  background-color: rgba(255, 255, 255, .7);
  padding-top: 10px;
  padding-bottom: 6px;
  border-radius: 6px;
  display: flex;
}

.head {
  justify-content: center;
  text-align: center;
  width: 120px;
}

/*.barcode.code-box{flex: 1}*/
.head img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px #aad7fb solid;
}

.head .name {
  margin-top: 5px;
}

.head .van-icon {
  color: gray;
}

.barcode-sub {
  text-align: left;
  margin-top: 10px;
}

.barcode-sub p {
  margin: 0;
}

.barcode-sub p span {
  color: gray;
}

.queue-wrap {
  /*background: #5daeff url("../../../../../Public/images/breakLine.png") no-repeat 0 0;*/
  /*background-image: linear-gradient(to bottom right, #dadcde, #206ee8, #d6d0bc);*/
  background-color: rgba(25, 137, 250, .7);
  padding: 10px;
  border-radius: 6px;
  margin-top: 8px;
}

.queue-wrap ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  text-align: center;
}

.queue-wrap ul li {
  color: #ffd01e;
  font-weight: bold;
  line-height: 1.2em;
  font-size: 2em;
  margin: 10px;
  padding: 10px .4em;
  /*background-color: rgba(25,137,250,.7);*/
  /*border-radius: 30px;*/
}

.queue-wrap ul li:nth-child(even) {
  border-left: 1px rgba(255, 255, 255, .3) solid;
}

.queue-wrap ul li .list-dec {
  font-size: .6em;
  line-height: 1.2em;
  color: #f5f4f4;
  font-weight: normal;
  margin-top: .5em;
}

.queue-wrap ul li .van-icon {
  border-radius: 50%;
  color: #1989fa;
  padding: 2px;
  color: #fff;
}

.queue-wrap .queue-wrap-header {
  color: #f5f4f4;
}

.van-tabs {
  margin-top: 15px;
}

.van-tab {
  color: #222;
}

.van-tab__text {
  font-weight: bold;
}

.van-tabs__line {
  background: rgb(33, 150, 243);
}

.van-tab__pane {
  margin-bottom: 10px;
}

.van-tab__pane > h3 {
  background-color: #fff;
  margin: 0;
  padding-top: 15px;
  padding-bottom: 10px;
  font-weight: normal;
  color: gray;
  padding-left: 20px;
  position: relative;
  font-size: .8em;
}

.van-tab__pane > h3:before {
  content: " ";
  width: 8px;
  height: .8em;
  position: absolute;
  top: 50%;
  left: 5px;
  margin-top: -.2em;
  border-radius: 2.5px 5px;
  background-color: #1989fa;
}

.van-grid {
  background-color: #fff;
}

.van-grid-item__content .van-icon {
  position: inherit;
}

.van-grid-item__content .van-icon .van-info {
  transform: rotateZ(-45deg);
  padding: 5px;
  background-color: rgba(0, 0, 0, .3);
  margin-top: -30px;
}

.shown-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.uncheck-list li {
  background-color: #fff;
  display: flex;
}

.uncheck-list li .icon {
  width: 40px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uncheck-list li .uncheck-list_cont {
  flex: 1;
}

.uncheck-list li .uncheck-list_cont h4 {
  margin-bottom: 5px;
}

.uncheck-list li .uncheck-list_cont p {
  margin-top: 0;
  color: gray;
}

.van-step--vertical .van-step__line {
  background-color: #c8c9cc;;
}

.van-step__title {
  color: #222;
}

.van-step__title p {
  color: gray;
}

.van-step__title--active {
  color: #07c160;
}

.scan-code {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 9;
  background-color: #fff;
}

.scan-code-header {
  flex: 1;
  background-color: #fff;
  background-image: url("~@/assets/images/queuing_header3.png");
  background-position: center 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 15px;
  box-shadow: 0 0px 15px rgba(0, 0, 0, .3);
  color: #fff;
}

.scan-code-header .van-image {
  width: 14em;
  height: 14em;
  background: #f7f8fa;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}

.scan-code-body {
  height: 60%;
  background-color: #fff;
}

.input-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 4em 4em 2em 4em;
}

.input-wrap .van-cell {
  flex: 1;
  border-top: 1px #e0e0e0 solid;
  border-bottom: 1px #e0e0e0 solid;
  font-weight: 500;
  font-size: 2.6em;
}

.operator-tip h4 {
  font-size: 1.4em;
  font-weight: 500;
  margin-bottom: .5em;
}

.operator-tip {
  color: #333;
  margin: 4em 2em;
  font-size: 2em;
  line-height: 1.5em;
  display: flex;
}

.side-right {
  width: 4.2em;
  position: fixed;
  bottom: 5em;
  right: .6em;
  z-index: 10;
  font-size: 2em;
}

.side-right .van-button {
  margin: .3em;
}

/*选项卡内容默认高度*/
.m-van-tabs .van-tab__pane {
  min-height: calc(100vh - 600px);
  background-color: #fff;
  padding-bottom: 5em;
}

/*金华中心医院*/
.jh-zxyy .head .van-icon {
  color: rgb(3, 123, 113);
}

.jh-zxyy .queue-wrap {
  background-color: #82bf9e;
}

.jh-zxyy .queue-wrap ul li {
  /*background-color: rgba(3,123,113,.7);*/
}

.jh-zxyy .van-tab__pane > h3:before {
  background-color: rgb(3, 123, 113);
}

.History-box {
  display: flex;
  flex-direction: row;
  margin: 0 4em;
  padding-bottom: 2em;
  flex-flow: wrap;
}

.History-box-item {
  display: flex;
  height: 2em;
  align-items: center;
  font-size: 1.8em;
  background-color: #ecefef;
  //border: 0.1em rgb(239, 235, 235) solid;
  color: #7b7878;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 1em;
  margin: 0.7em 0em 0em 1em;
}

.unCheck-wrap {
  display: flex;
  flex-direction: column;
  padding: 0.6em 0.6em 0.6em 0.6em;
  border: 1px rgb(239, 235, 235) solid;
  border-radius: 10px;
  font-size: 14px;
  margin-top: 5px;
  margin-right: 4.5em;
  min-height: 70px;
}


.unCheck {
  display: flex;
  flex-direction: column;
  justify-content: left;
  line-height: 3em;
}

.font-length {
  /* 设置一个固定的宽度 */
  width: 200px; /* 请根据需求调整宽度 */

  /* 防止文本换行 */
  white-space: nowrap;

  /* 隐藏超出容器的内容 */
  overflow: hidden;

  /* 当文本溢出时显示省略号，但注意text-overflow仅在设置了overflow:hidden和white-space:nowrap或wrap时生效，
     并且在大多数现代浏览器中都支持，包括IE9及以上版本 */
  text-overflow: ellipsis;
}

.unCheck-box-rq {
  display: flex;
  flex-flow: column;
  align-items: flex-end;
}

.unCheck-box {
  display: flex;
  justify-content: space-between;
  width: 8em;
  margin-left: 1em;
  margin: 0.3rem 0.3rem 0.3rem 0.3rem;
}

.unCheck-tips {
  color: rgba(192, 193, 193, 0.9);
  font-size: 23px;
  margin-left: 0.2em;
}

.message {
  .van-field {
    border: 1px solid #e2e2e2;
    width: 90%;
    margin: 12px auto 28px auto;
    background: #f6f6f6;
  }
}

.scrollBar {
  margin-top: 0.5em;
  overflow-x: auto;
  color: red;
  font-size: 24px;
  font-weight: bold;
}

.searchHistoryDel {
  display: flex;
  justify-content: space-between;
  padding-right: 5.5em;
  padding-left: 4em;
  padding-top: 1em;
  color: #7b7878;
}

.pickup-method {
  border: 1px solid #e2e2e2;
  display: flex;
  flex-direction: column;
  margin: 2em 2em 2em 2em;
  padding: 2em 2em 2em 2em;
  border-radius: 2em;
}

.switchover {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 0.5em;
  padding: 0.8em;
}

.van-grid-item__content img {
  width: 40%;
}


.van-text {
  font-size: 2.3rem;
  margin-top: 1rem;
  color: #474646;
}

.swipe-tip{
  position: absolute;
  width: 20px;
  top: -10px;
  right: 0;
  bottom: -15px;
  background-color: rgba(255,255,255,.1);
  display: flex;
  align-items: center;
  width: 30px;
  padding: 0 25px 0 10px;
  color: rgba(255,255,255,.3);
  -webkit-animation: free_download 1s linear alternate infinite;
  animation: free_download 1s linear alternate infinite;
}
@-webkit-keyframes free_download{
  0%{-webkit-transform:scale(0.9);}
  100%{-webkit-transform:scale(1);}
}
@keyframes free_download{
  0%{transform:scale(0.9);}
  100%{transform:scale(1);}
}
</style>
